import React from 'react';
import ParametroProSolutoBService from '../../../../lib/api/parametroProSolutoB/parametroProSolutoBService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroProSolutoB extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametrosProSolutoB()
    {
       return ParametroProSolutoBService.obterExcel();
    }

    enviarParametrosEventGrid()
    {
        return ParametroProSolutoBService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametrosProSolutoB}
                enviarExcelParametros={ParametroProSolutoBService.parametroProSolutoBExcelPost}
                deletarExcelParametros={ParametroProSolutoBService.deletarExcelParametros}
                nomeDoArquivo='Parametro ProSolutoB'
            ></TemplateParametro>
        );
    }
}

export default ParametroProSolutoB